import React from "react";

const BestInTech = () => {
    const Insights = {
        ONE: {
            title: "200 Million+",
            desc: "Sessions where our AI has been tested, and our user base is growing fast.",
            color: "#6C63FF"
        },
        TWO: {
            title: "Avg 45%",
            desc: "Boost in conversion delivered to our customers.",
            color: "#6C63FF"
        },
        THREE: {
            title: "99.8%",
            desc: "Accuracy in our Cookie-less AI uniquely classifying and categorizing an anonymous visitor.",
            color: "#6C63FF"
        },
        FOUR: {
            title: "73%",
            desc: "Accuracy in predicting an anonymous visitor's buying intent.",
            color: "#6C63FF"
        },
        FIVE: {
            title: "0.002",
            desc: "second is all it takes for our superfast AI to make prediction.",
            color: "#6C63FF"
        }
    }
  return (
    <div id="insights">
      <div className="container bestTech-container">
        <h2 className="newsLatest-title text-center pt-2" x-intersect="$el.classList.add('fadeInUp-parallax')">
          The Best In Class Technology
        </h2>
        <p className="text-center"  x-intersect="$el.classList.add('fadeInUp-parallax')">
          Uncover the hidden value of your anonymous visitors with our
          disruptive cookie-less AI.
        </p>
        <div className="insight-container flex pt-2 pt-sm-5"  x-intersect="$el.classList.add('fadeInUp-parallax')">
                  <Insight
                      title={Insights.ONE.title}
                      desc={Insights.ONE.desc}
                      color={Insights.ONE.color}
                      cls={""}
                  
                  />
                  <Insight
                      title={Insights.TWO.title}
                      desc={Insights.TWO.desc}
                      color={Insights.TWO.color}
                      cls={""}
                  
                  />
                  <Insight
                      title={Insights.THREE.title}
                      desc={Insights.THREE.desc}
                      color={Insights.THREE.color}
                      cls={""}
                  
                  />
                  <Insight
                      title={Insights.FOUR.title}
                      desc={Insights.FOUR.desc}
                      color={Insights.FOUR.color}
                      cls={""}
                  
                  />
                  <Insight
                      title={Insights.FIVE.title}
                      desc={Insights.FIVE.desc}
                      color={Insights.FIVE.color}
                      cls={""}
                  
                  />
        </div>
      </div>
    </div>
  );
};

export default BestInTech;


export const Insight = ({title, desc, color, cls}) => {
    return (
        <div className="insight-item" x-intersect="$el.classList.add('feature-parallax')">
            <h2 style={{color: color}}>{title}</h2>
            <p> { desc }</p>
        </div>
    )
}
